import React, { useState } from "react";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromHTML,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Box } from "@mui/material";
import draftToHtml from "draftjs-to-html";

interface RichTextEditorProps {
  value: string;
  onChange: (htmlContent: string) => void;
  placeholder?: string;
}

const DescriptionRichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder = "Start typing here...",
}) => {
  const [editorState, setEditorState] = useState(() => {
    if (value) {
      const blocksFromHTML = convertFromHTML(value);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  });

  const handleEditorChange = (state: EditorState) => {
    setEditorState(state);
    const html = draftToHtml(convertToRaw(state.getCurrentContent()));
    onChange(html);
  };

  return (
    <Box
      sx={{
        minHeight: 250,
        border: "1px solid #ccc",
        borderRadius: 2,
        p: 1,
        "& .rdw-editor-toolbar": {
          backgroundColor: "#f5f5f5",
          border: "1px solid #ddd",
          borderRadius: "4px",
        },
        "& .rdw-option-wrapper": {
          borderRadius: "4px",
          margin: "0 2px",
          backgroundColor: "#fff",
        },
        "& .rdw-option-wrapper:hover": {
          backgroundColor: "#e0e0e0",
        },
        "& .rdw-option-active": {
          backgroundColor: "#614438",
          color: "#fff",
        },
        "& .rdw-editor-main": {
          minHeight: "200px",
          padding: "10px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          backgroundColor: "#fff",
          "& p": {
            margin: "0 0 8px 0",
          },
        },
      }}
    >
      <Editor
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        placeholder={placeholder}
        toolbar={{
          options: [
            "inline",
            "blockType",
            "list",
            "textAlign",
            "link",
            "image",
            "history",
          ],
          inline: { options: ["bold", "italic", "underline", "strikethrough"] },
          blockType: { options: ["Normal", "H1", "H2", "H3", "Blockquote"] },
          list: { options: ["unordered", "ordered"] },
          textAlign: { options: ["left", "center", "right", "justify"] },
        }}
      />
    </Box>
  );
};

export default DescriptionRichTextEditor;
